import { stripMarkdown } from './format';

const SOURCE_SUFFIX_RE = /\s(?:[-|]\s)?(?:The Economic Times|Economic Times|ETMarkets|NDTV|LiveMint|Livemint|Moneycontrol|Business Standard|The Hindu|Hindustan Times|Financial Express|Times of India|The Indian Express|Indian Express|Zee News|DNA India)\s*$/i;
const NOISE_PREFIX_RE = /^(?:latest news|breaking news|market news|stock market news)\s*[:|-]\s*/i;
const NOISE_PHRASES = [
  /\b(?:latest news|live updates|stock market updates)\b/gi,
  /\b(?:watch video|photos|videos)\b/gi,
  /\b(?:explained|all you need to know)\b/gi,
];

const ACTION_WORDS = [
  'approves', 'approved', 'rejects', 'rejected', 'orders', 'ordered', 'fines', 'fined',
  'summons', 'raids', 'arrests', 'arrested', 'files', 'filed', 'sues', 'sued',
  'settles', 'settled', 'launches', 'launched', 'reports', 'reported', 'posts',
  'posted', 'rises', 'falls', 'drops', 'jumps', 'plans', 'faces', 'wins', 'loses',
  'seeks', 'gets', 'receives', 'raises', 'cuts', 'slips', 'gains',
];

function cleanTitle(title) {
  let text = stripMarkdown(title || 'Untitled')
    .replace(SOURCE_SUFFIX_RE, '')
    .replace(NOISE_PREFIX_RE, '')
    .replace(/\s+/g, ' ')
    .trim();

  NOISE_PHRASES.forEach(pattern => {
    text = text.replace(pattern, '').replace(/\s+/g, ' ').trim();
  });

  text = text.replace(/\s+:\s+/g, ': ').replace(/\s+-\s+/g, ' - ');
  return text || 'Untitled';
}

function includesCompany(text, company) {
  if (!company) return true;
  const companyWords = company.toLowerCase().split(/\s+/).filter(word => word.length > 2);
  const lower = text.toLowerCase();
  return companyWords.some(word => lower.includes(word));
}

function hasAction(text) {
  const lower = text.toLowerCase();
  return ACTION_WORDS.some(word => new RegExp(`\\b${word}\\b`, 'i').test(lower));
}

function categoryLabel(record) {
  const category = record?.categories?.[0];
  if (!category) return '';
  return category.charAt(0).toUpperCase() + category.slice(1);
}

export function displayHeadline(record) {
  if (!record) return 'Untitled';
  const title = cleanTitle(record.title);
  const company = record.company || '';

  if (includesCompany(title, company) && hasAction(title)) return title;
  if (includesCompany(title, company)) {
    const category = categoryLabel(record);
    return category ? `${category}: ${title}` : title;
  }

  const prefix = company || categoryLabel(record);
  return prefix ? `${prefix}: ${title}` : title;
}
